module.exports = __webpack_public_path__ + "img/javascript-logo.d5ee029a.png";